import HelpStepsComponent from './containers/helpStepsComponent'

export { default as HelpStepsLayout } from './components/helpStepsLayout' 

export default HelpStepsComponent